module.exports = __webpack_public_path__ + "img/undertakingCases5.08b0ac85.jpg";